import { NewScanScheduleStep, NewScanScheduleStepHeader } from "./types";

export const SCHEDULE_SCAN_WIZARD_STEPS_ORDER: NewScanScheduleStep[] = [
  NewScanScheduleStep.ScanDetails,
  NewScanScheduleStep.AttachProviders,
  NewScanScheduleStep.AttachWorkerPool,
  NewScanScheduleStep.DefineScope,
  NewScanScheduleStep.ResourceFilters,
  NewScanScheduleStep.SetFrequency,
  NewScanScheduleStep.Summary,
];

export const SCHEDULE_SCAN_WIZARD_STEP_LABELS: Record<NewScanScheduleStep, string> = {
  [NewScanScheduleStep.ScanDetails]: "Scan details",
  [NewScanScheduleStep.AttachProviders]: "Attach provider",
  [NewScanScheduleStep.AttachWorkerPool]: "Attach worker pool",
  [NewScanScheduleStep.DefineScope]: "Define scope of resources",
  [NewScanScheduleStep.ResourceFilters]: "Resource filters (optional)",
  [NewScanScheduleStep.SetFrequency]: "Set frequency",
  [NewScanScheduleStep.Summary]: "Summary",
};

export const SCHEDULE_SCAN_WIZARD_STEP_HEADERS: Record<
  NewScanScheduleStep,
  NewScanScheduleStepHeader
> = {
  [NewScanScheduleStep.ScanDetails]: {
    title: "Add scan details",
    description:
      "Name your scan, add a description and labels for improved organization and filtering",
  },
  [NewScanScheduleStep.AttachProviders]: {
    title: "Attach provider",
    description: "Attach provider, and integrate it",
  },
  [NewScanScheduleStep.AttachWorkerPool]: {
    title: "Attach worker pool",
    description:
      "Choose a private worker pool to run the scan. A private worker pool is required to schedule infrastructure scanning and reach resources in private network",
  },
  [NewScanScheduleStep.DefineScope]: {
    title: "Define scope of resources",
    description:
      "Choose which resource types to include in the scan. Each type comes with a description to help you understand what it covers.",
  },
  [NewScanScheduleStep.ResourceFilters]: {
    title: "Resource filters",
    description: "Add filters per resource type to further narrow down the scan results",
  },
  [NewScanScheduleStep.SetFrequency]: {
    title: "Set scan frequency",
    description: "Choose how often the scan should run to keep your unmanaged resources up to date",
  },
  [NewScanScheduleStep.Summary]: {
    title: "Summary",
    description:
      "Once the scan is scheduled, you can update its settings or frequency at any time.",
  },
};
